module.exports = __webpack_public_path__ + "img/BaliBody2.d95a9901.jpg";